import React from 'react';
import PropTypes from 'prop-types';

const NoImageIcon = props => {
  const { className } = props;

  return (
    <svg
      className={className}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        {/* Building outline */}
        <rect x="16" y="12" width="32" height="44" strokeWidth="2.5" rx="1" />
        
        {/* Windows - top row */}
        <rect x="22" y="18" width="6" height="6" strokeWidth="2" />
        <rect x="36" y="18" width="6" height="6" strokeWidth="2" />
        
        {/* Windows - middle row */}
        <rect x="22" y="28" width="6" height="6" strokeWidth="2" />
        <rect x="36" y="28" width="6" height="6" strokeWidth="2" />
        
        {/* Windows - lower row */}
        <rect x="22" y="38" width="6" height="6" strokeWidth="2" />
        <rect x="36" y="38" width="6" height="6" strokeWidth="2" />
        
        {/* Door */}
        <rect x="28" y="48" width="8" height="8" strokeWidth="2" />
        
        {/* Roofline detail */}
        <line x1="16" y1="12" x2="32" y2="6" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="32" y1="6" x2="48" y2="12" strokeWidth="2.5" strokeLinecap="round" />
      </g>
    </svg>
  );
};

const { string } = PropTypes;

NoImageIcon.defaultProps = {
  className: null,
};

NoImageIcon.propTypes = {
  className: string,
};

export default NoImageIcon;
